/* tomorrow-night */
const base00 = '#35434e'; // was #1d1f21;
const base01 = '#282a2e';
const base02 = '#373b41';
const base03 = '#969896';
const base04 = '#b4b7b4';
const base05 = '#c5c8c6'; // base05
const base06 = '#e0e0e0';
const base07 = '#ffffff';
const base0c = '#cc6666'; // base08
const base09 = '#ec9c65';
const base0a = '#f0c674';
const base0b = '#b5bd68';
const base08 = '#8abeb7'; // base0c
const base0d = '#81a2be'; // base0d
const base0e = '#b294bb';
const base0f = '#a3685a';

const RED = base0c;
const YELLOW = base0a;
// const BLUE = base0d;
// const GREEN = base0b;

const DEFAULT_AUTORUN_DELAY = 1000;

const TEMPLATE = document.createElement('template');
TEMPLATE.innerHTML = `
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.65.16/codemirror.min.css">
<style>

:host {
    display: block;
    font-family: var(--ui-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen-Sans, Ubuntu, Cantarell,
      "Helvetica Neue", "Source Sans Pro"), sans-serif;
    line-height: 1.5;
    margin-top: 8px;
    --_base-00: var(--base-00, ${base00});
    --_base-01: var(--base-01, ${base01});
    --_base-02: var(--base-02, ${base02});
    --_base-03: var(--base-03, ${base03});
    --_base-04: var(--base-04, ${base04});
    --_base-05: var(--base-05, ${base05});
    --_base-06: var(--base-06, ${base06});
    --_base-07: var(--base-07, ${base07});
    --_base-08: var(--base-08, ${base08});
    --_base-09: var(--base-09, ${base09});
    --_base-0a: var(--base-0a, ${base0a});
    --_base-0b: var(--base-0b, ${base0b});
    --_base-0c: var(--base-0c, ${base0c});
    --_base-0d: var(--base-0d, ${base0d});
    --_base-0e: var(--base-0e, ${base0e});
    --_base-0f: var(--base-0f, ${base0f});
    --_semantic-red: var(--semantic-red, ${RED});
    --_semantic-orange: var(--semantic-orange, ${YELLOW});

  }
  :host([hidden]) {
    display: none;
  }

  slot { display: none; }

  .original-content {
    display: none;
  }

  .editors.hidden {
    display: none;
  }

  .__code-playground-container {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    height: 100%;
    min-width: 300px;
    border-radius: 8px;
    width: 100%;
    margin: 0;
    background: transparent
  }

  .__code-playground-editor {
    border: 1px solid #ccc;
    background: var(--base-00);
    color: var(--base-05);
  }

  .__code-playground-container textarea {
    display: block;

    color: var(--text-color);
    background: var(--ui-background);

    min-height: 4em;
    height: 100%;
    width: 100%;

    resize: vertical;

    border: var(--ui-border, 1px solid rgba(0,0,0,.25));
    outline: none;
    font-family: var(--monospace-font-family), 'Berkeley Mono', 'JetBrains Mono', 'IBM Plex Mono', 'Fira Code', monospace;
    font-size: 16px;
    line-height: 1.2;
  }


  .__code-playground-container label {
    display: block;
    font-weight: 700;
    padding-top: 4px;
    padding-bottom: 4px;
}


  :host div.__code-playground-button-bar:not(.visible) {
    display: none !important;
  }

  button svg {
    height: 1em;
    width: 1em;
    margin-right: .55em;
    vertical-align: -.12em;
  }
  

  #run-button:not(.visible) {
    display: none !important;
  }

  .__code-playground-result {
    width: 100%;
    margin: .5em 0 0 0;
  }


  .__code-playground-output {
    display:  flex;
    flex-flow: column;
  }

  .__code-playground-output:not(.visible) {
    display: none !important;
  }

  .__code-playground-output textarea {
    width: calc(100% - 16px);
  }

  .__code-playground-output button {
    appearance: none;
    font-family: var(--ui-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI",      Roboto, Oxygen-Sans, Ubuntu, Cantarell,      "Helvetica Neue", "Source Sans Pro"), sans-serif;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 8px;
    border: 1px solid var(--base-05, #c5c8c6);
    color: var(--base-00, #35434e);
    background: var(--base-07, #ffffff);
    padding: 4px 16px;
    min-height: 42px;
    min-width: 42px;
    filter: drop-shadow(4px 4px 8px #00000020);
  }

  .__code-playground-output button:hover {
    background: var(--base-06, #e0e0e0);
    background-opacity: .4;

  }

  .__code-playground-output button:active {
    background: var(--base-07, #ffffff);
    color: var(--base-00, #35434e);
    filter: drop-shadow(0px 0px 4px #00000040);
  }


  .__code-playground-output button:disabled, 
  .__code-playground-output button:disabled:hover {
    background: var(--base-07, #ffffff);
    color: var(--base-04, #b4b7b4);
    filter: none;
  }




  .__code-playground-output .row {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }

  .__code-playground-output .row > * {
    flex: .25;
  }

  .__code-playground-output .row > *:not(:first-child) {
    margin-left: 8px;
  }

  .__code-playground-output .row > *:not(:last-child) {
    margin-right: 8px;
  }

  .__code-playground-output .row > *:first-child {
    margin-left: 0;
  }

  .__code-playground-output .row > *:last-child {
    margin-right: 0;
  }

  .__code-playground-output .stack {
    display: flex;
    flex-flow: column;
    margin-top: 8px;
    margin-bottom: 8px;
  }


  .__code-playground-console {
    display: block;
    max-height: 50vh;
    margin: .5em 0 0 0;
    overflow: auto;

    padding: 8px 8px 8px 1em;
    border-radius: 8px;

    color: var(--_base-05);
    background: var(--_base-00);
    border: var(--ui-border, 1px solid rgba(0, 0, 0, .2));

    font-family: var(--monospace-font-family), 'Berkeley Mono', 'JetBrains Mono', 'IBM Plex Mono', 'Fira Code', monospace;
    font-size: 1em;

    white-space: pre-wrap;
  }

  .__code-playground-console:not(.visible) {
    display: none !important;
  }


  .__code-playground-console::selection, 
  .__code-playground-console *::selection {
    background: var(--selection-background, var(--_base-01));
    color: var(--selection-color, inherit);
  }


  .__code-playground-console .sep {
    color: var(--_base-05);
  }
  .__code-playground-console .index {
    color: var(--_base-05);
    opacity: .3;
    float: left;
    width: 0;
    font-style: italic;
  }
  .__code-playground-console .boolean {
    color: var(--_base-0e);
    font-weight: bold;
  }
  .__code-playground-console .empty {
    color: var(--_base-0e);
    font-style: italic;
  }
  .__code-playground-console .null {
    color: var(--_base-0e);
    font-style: italic;
  }
  .__code-playground-console .string {
    color: var(--_base-0a);
    font-weight: bold;
  }
  .__code-playground-console .function {
    color: var(--_base-0b);
  }
  .__code-playground-console .number {
    color: var(--_base-0e);
  }
  .__code-playground-console .property {
    color: var(--_base-0b);
  }
  .__code-playground-console .object {
    color: var(--_base-0b);
  }
  .__code-playground-console .error {
    display: inline;
    padding: 4px 8px;
    background: var(--red-800);
    color: white;
    border-left: 4px solid var(--_semantic-red);
    border-radius: 4px;
    box-decoration-break: clone;
  }
  .__code-playground-console .warning {
    color: var(--_semantic-orange);
  }
  .__code-playground-console .log {
    color: var(--blue--200);
  }
  .__code-playground-console .group {
    font-weight: bold;
  }
  



@media (prefers-color-scheme: dark) {
  :root {
    --selection-background: var(--primary-color);
    --selection-color: #fff;
  }
}
  

/* Tomorrow Comment */
.hljs-comment {
    color: var(--_base-04);
}

/* Function (JS) and tag (HTML) names */
.hljs-tag, .hljs-title {
    color: var(--_base-0a);
}
  
/* Tomorrow Red */
.hljs-variable,
.hljs-attribute,
.hljs-tag,
.hljs-regexp,
.ruby .hljs-constant,
.xml .hljs-tag .hljs-title,
.xml .hljs-pi,
.xml .hljs-doctype,
.html .hljs-doctype,
.css .hljs-id,
.css .hljs-class,
.css .hljs-pseudo {
  color: var(--_base-0c);
}

/* Tomorrow Orange */
.hljs-number,
.hljs-preprocessor,
.hljs-built_in,
.hljs-literal,
.hljs-params,
.hljs-constant {
  color: var(--_base-09);
  font-weight: normal;
}

/* Tomorrow Yellow */
.ruby .hljs-class .hljs-title,
.css .hljs-rules .hljs-attribute {
    color: var(--_base-0a);
}

/* Tomorrow Green */
.hljs-string,
.hljs-value,
.hljs-inheritance,
.hljs-header,
.ruby .hljs-symbol,
.xml .hljs-cdata {
  color: var(--_base-0b);
}

/* Tomorrow Aqua */
.css .hljs-hexcolor {
  color: var(--_base-08);
}

/* Tomorrow Blue */
.hljs-function,
.python .hljs-decorator,
.python .hljs-title,
.ruby .hljs-function .hljs-title,
.ruby .hljs-title .hljs-keyword,
.perl .hljs-sub,
.javascript .hljs-title,
.coffeescript .hljs-title {
  color: var(--_base-0d);
  font-weight: bold;
}

/* Tomorrow Purple */
.hljs-keyword,
.javascript .hljs-function {
  color: var(--_base-0e);
  font-weight: bold;
}

.hljs {
  display: block;
  background: var(--_base-00);
  color: var(--_base-05);
  padding: 0.5em;
}

.coffeescript .javascript,
.javascript .xml,
.tex .hljs-formula,
.xml .javascript,
.xml .vbscript,
.xml .css,
.xml .hljs-cdata {
    opacity: 0.5;
}

// Rouge typographic adjustments.
// See https://github.com/rouge-ruby/rouge/wiki/List-of-tokens

.highlight .c1,     // Single line comment
.highlight .cm      // Multiline comment
  {
    font-style: italic;
}

.highlight .k,       // keywords
.highlight .kc,       // keywords constant
.highlight .kd,       // keywords declaration
.highlight .kn,       // keywords namespace
.highlight .kp,       // keywords pseudi
.highlight .kr,       // keywords reserved
.highlight .kt,       // keywords type
.highlight .kv       // keywords variable
{
  font-weight: bold;
}

.CodeMirror {
  font-family: var(--monospace-font-family), 'Berkeley Mono', 'JetBrains Mono', 'IBM Plex Mono', 'Fira Code', monospace;
  color: inherit;
}
.cm-s-tomorrow-night.CodeMirror { background: transparent; }
.cm-s-tomorrow-night div.CodeMirror-selected { background: var(--selection-background, var(--_base-01)); color: var(--selection-color, inherit);}

.cm-s-tomorrow-night .CodeMirror-line::selection, .cm-s-tomorrow-night .CodeMirror-line > span::selection, .cm-s-tomorrow-night .CodeMirror-line > span > span::selection { background: var(--selection-background, rgba(45, 45, 45, 0.99)); color: var(--selection-color, inherit);}

.cm-s-tomorrow-night .CodeMirror-line::-moz-selection, .cm-s-tomorrow-night .CodeMirror-line > span::-moz-selection, .cm-s-tomorrow-night .CodeMirror-line > span > span::-moz-selection { background: var(--selection-background, rgba(45, 45, 45, 0.99)); color: var(--selection-color, inherit);}

.cm-s-tomorrow-night .CodeMirror-gutters { background: transparent; border-right: 0px; }
.cm-s-tomorrow-night .CodeMirror-guttermarker { color: var(--_base-0c); }
.cm-s-tomorrow-night .CodeMirror-guttermarker-subtle { color: var(--_base-03); }
.cm-s-tomorrow-night .CodeMirror-linenumber { color: var(--_base-04); opacity: .7; }
.cm-s-tomorrow-night .CodeMirror-cursor { border-left: 1px solid var(--_base-0d); }

.cm-s-tomorrow-night span.cm-comment { color: var(--_base-04); }
.cm-s-tomorrow-night span.cm-atom { color: var(--_base-0e); }
.cm-s-tomorrow-night span.cm-number { color: var(--_base-0e); }

.cm-s-tomorrow-night span.cm-property, .cm-s-tomorrow-night span.cm-attribute { color: var(--_base-0a); }
.cm-s-tomorrow-night span.cm-keyword { color: var(--_base-0c); }
.cm-s-tomorrow-night span.cm-string { color: var(--_base-0b); }

.cm-s-tomorrow-night span.cm-variable { color: var(--_base-0b); }
.cm-s-tomorrow-night span.cm-variable-2 { color: var(--_base-0d); }
.cm-s-tomorrow-night span.cm-def { color: var(--_base-09); }
.cm-s-tomorrow-night span.cm-bracket { color: var(--_base-05); }
.cm-s-tomorrow-night span.cm-tag { color: var(--_base-0a); }
.cm-s-tomorrow-night span.cm-link { color: var(--_base-0e); }
.cm-s-tomorrow-night span.cm-error { background: var(--_base-0c); color: var(--_base-03); }

.cm-s-tomorrow-night .CodeMirror-activeline-background { background: var(--_base-02); }
.cm-s-tomorrow-night .CodeMirror-matchingbracket { text-decoration: underline; color: white !important; }    


.CodeMirror .marked div.CodeMirror-linenumber {
  opacity: 1;
  color: var(--base-07, #fff);
}

.CodeMirror .marked pre.CodeMirror-line::before {
  content: "";
  position: absolute;
  top: 0; 
  left: 0;
  width: 100%; 
  height: 100%;  
  opacity: .5; 
  z-index: -1;
  background: var(--editor-marked-line, var(--cyan-700, #0c6abe)) !important;
}
</style>
<slot name="style"></slot>
`;

export class CodePlaygroundElement extends HTMLElement {
  private dirty = false;
  private containerId: string;
  private moduleMap: { [module: string]: string };
  private resizeObserver: ResizeObserver;
  private runTimer: number;

  private consoleContent: string = ''; // Pending content not yet displayed in the console.

  // True if the user has made some changes to one of the editor
  private edited = false;
  private resetting = false;

  timers: { [key: string]: number } = {};

  /** The name of the attributes use the dash convention, as per HTML5 spec:
   *
   * > Any namespace-less attribute that is relevant to the element's
   * > functioning, as determined by the element's author, may be specified on
   * > an autonomous custom element, so long as the attribute name is
   * > XML-compatible and contains no ASCII upper alphas.
   *
   * However, React properties expect camelCase names, so we also
   * support those (read-only).
   *
   */
  static attributes = {
    showLineNumbers: 'show-line-numbers',
    buttonBarVisibility: 'button-bar-visibility',
    autorun: 'autorun',
    markLine: 'mark-line',
    markJavascriptLine: 'mark-javascript-line',
    markHtmlLine: 'mark-html-line',
    compactWidth: 'compact-width',
  };

  static get observedAttributes(): string[] {
    return Object.values(CodePlaygroundElement.attributes);
  }

  attributeChangedCallback(
    name: string,
    oldValue: string,
    newValue: string
  ): void {
    if (oldValue === newValue) return;
    const attributes = CodePlaygroundElement.attributes;
    if (
      name === attributes.markLine ||
      name === attributes.markJavascriptLine
    ) {
      mark(this.shadowRoot, 'javascript', newValue);
    } else if (name === attributes.markHtmlLine) {
      mark(this.shadowRoot, 'html', newValue);
    } else if (name === attributes.showLineNumbers) {
      this.shadowRoot
        .querySelectorAll('textarea + .CodeMirror')
        .forEach((x) =>
          x?.['CodeMirror']?.setLineNumbers(this.showLineNumbers)
        );
    }
  }

  constructor() {
    super();

    this.moduleMap = window['moduleMap'] ?? {};
    this.attachShadow({ mode: 'open', delegatesFocus: true });
  }

  get isContentEditable(): boolean {
    return true;
  }

  disconnectedCallback(): void {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;

    this.shadowRoot.innerHTML = '';
    this.dirty = true;
    if (this.runTimer) clearTimeout(this.runTimer);
    this.edited = false;
    this.resetting = false;
  }

  connectedCallback(): void {
    const shadowRoot = this.shadowRoot;

    if (!this.id) this.id = randomId();

    shadowRoot.appendChild(TEMPLATE.content.cloneNode(true));

    const styleSlot =
      shadowRoot.querySelector<HTMLSlotElement>('slot[name=style]');
    if (styleSlot) {
      const styleContent = styleSlot
        .assignedNodes()
        .map((node: HTMLElement) => node.innerHTML)
        .join('')
        .trim();
      if (styleContent) {
        const style = document.createElement('style');
        style.innerHTML = styleContent;
        shadowRoot.appendChild(style);
      }
    }

    const container = document.createElement('div');
    this.containerId = randomId();
    container.id = this.containerId;

    const containerContent = `<div inert class="original-content" translate="no"><slot name="html"></slot><slot name="javascript"></slot></div>

  <div class="__code-playground-container" translate="no">
  
    <div class="editors hidden" part="editors"></div>

    <div class="__code-playground-button-bar" part="button-bar">
      <button id="reset-button" part="button" disabled><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="history" class="svg-inline--fa fa-history fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 255.532c.252 136.64-111.182 248.372-247.822 248.468-64.014.045-122.373-24.163-166.394-63.942-5.097-4.606-5.3-12.543-.443-17.4l16.96-16.96c4.529-4.529 11.776-4.659 16.555-.395C158.208 436.843 204.848 456 256 456c110.549 0 200-89.468 200-200 0-110.549-89.468-200-200-200-55.52 0-105.708 22.574-141.923 59.043l49.091 48.413c7.641 7.535 2.305 20.544-8.426 20.544H26.412c-6.627 0-12-5.373-12-12V45.443c0-10.651 12.843-16.023 20.426-8.544l45.097 44.474C124.866 36.067 187.15 8 256 8c136.811 0 247.747 110.781 248 247.532zm-167.058 90.173l14.116-19.409c3.898-5.36 2.713-12.865-2.647-16.763L280 259.778V116c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v168.222l88.179 64.13c5.36 3.897 12.865 2.712 16.763-2.647z"></path></svg>Reset</button>

      <button id="run-button" part="button"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="play" class="svg-inline--fa fa-play fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zM48 453.5v-395c0-4.6 5.1-7.5 9.1-5.2l334.2 197.5c3.9 2.3 3.9 8 0 10.3L57.1 458.7c-4 2.3-9.1-.6-9.1-5.2z"></path></svg>Run</button>
    </div>

    <div class="__code-playground-result" translate="no">
      <div class="__code-playground-output" part="output" translate="no"></div>
    </div>

  </div>`;

    container.innerHTML = containerContent;
    shadowRoot.appendChild(container);

    // Add event handler for "run" and "reset" button
    shadowRoot
      .getElementById('run-button')
      .addEventListener('click', () => this.run());
    shadowRoot
      .getElementById('reset-button')
      .addEventListener('click', () => this.reset());

    // Track insertion/changes to slots
    shadowRoot.addEventListener('slotchange', () => {
      this.dirty = true;
      requestAnimationFrame(() => this.update());
    });

    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        shadowRoot
          .querySelectorAll('textarea + .CodeMirror')
          .forEach((x) => x?.['CodeMirror']?.refresh());
      });
    });

    this.updateButtonBar();
  }

  get outputStylesheets(): string[] {
    if (!this.hasAttribute('outputStylesheets')) return [];
    return this.getAttribute('outputStylesheets').split(' ');
  }
  set outputStylesheets(value: string[]) {
    this.setAttribute('outputStylesheets', value.join(' '));
  }

  get autorun(): 'never' | number {
    if (!this.hasAttribute('autorun')) return DEFAULT_AUTORUN_DELAY;
    const value = this.getAttribute('autorun');
    if (value === 'never') return 'never';
    if (isFinite(parseFloat(value))) return parseFloat(value);
    return DEFAULT_AUTORUN_DELAY;
  }

  set autorun(value: 'never' | number) {
    this.setAttribute('autorun', value.toString());
    this.updateButtonBar();
  }

  get buttonBarVisibility(): string {
    const val =
      this.getAttribute('button-bar-visibility') ??
      this.getAttribute('buttonBarVisibility') ??
      'auto';

    if (val === 'auto') {
      // Auto = show only when needed (some changes have been made to
      // the content)
      if (this.edited || this.autorun === 'never') return 'visible';
      return 'hidden';
    }
    return val;
  }

  set buttonBarVisibility(value: string) {
    this.setAttribute('buttonBarVisibility', value);
  }

  get compactWidth(): number {
    const value = this.getAttribute('compact-width');
    if (value && isFinite(parseFloat(value)))
      return Math.floor(parseFloat(value));
    return 80; // Default compact width threshold
  }

  set compactWidth(value: number) {
    this.setAttribute('compact-width', Math.floor(value).toString());
  }

  get buttonBarVisible(): boolean {
    return (
      this.shadowRoot
        .querySelector('.__code-playground-button-bar')
        ?.classList.contains('visible') ?? false
    );
  }

  updateButtonBar(): void {
    const buttonBarVisibility = this.buttonBarVisibility;

    const buttonBar = this.shadowRoot.querySelector(
      '.__code-playground-button-bar'
    );

    if (!buttonBar) return;

    const resetButton = this.shadowRoot.getElementById(
      'reset-button'
    )! as HTMLButtonElement;
    if (resetButton) resetButton.disabled = !this.edited;

    const runButton = this.shadowRoot.getElementById(
      'run-button'
    )! as HTMLButtonElement;
    if (runButton) runButton.disabled = false;

    runButton?.classList.toggle('visible', this.autorun === 'never');
    buttonBar?.classList.toggle('visible', buttonBarVisibility === 'visible');
  }

  // The content of the code section has changed. Rebuild the editors
  update(): void {
    if (!this.dirty) return;
    this.dirty = false;

    // 1. Update the button bar
    this.updateButtonBar();

    const shadowRoot = this.shadowRoot;
    const editors = shadowRoot.querySelector<HTMLElement>('.editors');
    // In some cases, update is triggered but the editors are not yet
    // available.
    if (!editors) return;

    // 2. Collect the content of each editor
    const slots = [
      ...shadowRoot.querySelectorAll<HTMLSlotElement>('.original-content slot'),
    ];
    let content = '';
    for (const slot of slots) {
      let text = slot
        .assignedNodes()
        .map((node: HTMLElement) => node.innerHTML)
        .join('');
      if (text) {
        // Remove empty comments. This 'trick' is used to work around
        // an issue where Eleventy ignores empty lines in HTML blocks,
        // so an empty comment is inserted, but it now needs to be removed
        // so that the empty line is properly picked up by CodeMirror. Sigh.
        text = text.replace(/<!-- -->/g, '');
        const language = slot.name.toLowerCase();
        content += `<label part="label">${
          { html: 'HTML', javascript: 'JavaScript', css: 'CSS', json: 'JSON' }[
            language
          ] ?? language
        }</label>
        <div part="editor" class="__code-playground-editor ${language}">
            <textarea spellcheck="false" autocorrect="off"  autocapitalize="off" data-language="${language}">${text}</textarea> 
        </div>`;
      }
    }
    editors.innerHTML = content;

    // 3. Setup editors
    // @todo: migrate to CodeMirror 6: https://codemirror.net/docs/migration/
    // @todo: bundle CodeMirror library with rollup
    // @todo: replace .fromTextArea() with new EditorView()
    // @todo: update CSS (see DOM Structure)
    if ('CodeMirror' in window && window.CodeMirror !== undefined) {
      this.resizeObserver.disconnect();
      shadowRoot
        .querySelectorAll<HTMLTextAreaElement>('.editors textarea')
        .forEach((x: HTMLTextAreaElement) => {
          // Watch for re-layout and invoke CodeMirror refresh when they happen
          this.resizeObserver.observe(x.parentElement);

          const lang =
            {
              ts: 'typescript',
              typescript: 'typescript',
              js: 'javascript',
              javascript: 'javascript',
              json: { name: 'javascript', json: true },
              css: 'css',
              html: { name: 'xml', htmlMode: true },
            }[x.dataset.language] ?? 'javascript';

          const editor = CodeMirror.fromTextArea(x, {
            lineNumbers: this.showLineNumbers,
            lineWrapping: true,
            mode: lang,
            theme: 'tomorrow-night',
          });
          editor.setValue(sanitizeInput(x.value));
          editor.setSize('100%', '100%');
          if (x.dataset.language === 'javascript')
            mark(shadowRoot, 'javascript', this.getAttribute('markLine'));

          mark(
            shadowRoot,
            x.dataset.language,
            this.getAttribute(`mark${toTitleCase(x.dataset.language)}Line`)
          );

          editor.on('change', () => this.editorContentChanged());
        });

      editors.classList.remove('hidden');
    }

    // 4. Run the playground
    if (this.autorun !== 'never') this.run();

    // Refresh the codemirror layouts
    // (important to get the linenumbers to display correctly)
    if ('CodeMirror' in window && window.CodeMirror !== undefined) {
      setTimeout(
        () =>
          shadowRoot
            .querySelectorAll('textarea + .CodeMirror')
            .forEach((x) => x?.['CodeMirror']?.refresh()),
        128
      );
    }
  }

  async run() {
    const shadowRoot = this.shadowRoot;
    const result = shadowRoot.querySelector('.__code-playground-result');
    if (!result) return;

    // Remove all the script tags that might be there.
    // (This includes the script tags that were added by the previous run)
    result
      .querySelectorAll('.__code-playground-result > script')
      .forEach((x) => result.removeChild(x));

    // Remove all the consoles that might be there.
    // result
    //   .querySelectorAll('.__code-playground-result >.__code-playground-console')
    //   .forEach((x) => result.removeChild(x));

    this.pseudoConsole.clear();

    // Setup the HTML in 'output'
    let htmlContent = '';
    const htmlEditor = shadowRoot.querySelector(
      'textarea[data-language="html"] + .CodeMirror'
    );
    if (htmlEditor) {
      htmlContent = htmlEditor['CodeMirror']?.getValue();
    } else {
      htmlContent =
        shadowRoot.querySelector<HTMLTextAreaElement>(
          'textarea[data-language="html"]'
        )?.value ?? '';
    }
    // If the HTML content contains any <script> tags, extract them
    const scriptTags = htmlContent.match(/<script.*>.*?<\/script>/g);
    scriptTags?.forEach((x) => {
      const m = x.match(/<script([^>]*?)>(.*)<\/script>/);
      const regex = new RegExp(
        '[\\s\\r\\t\\n]*([a-z0-9\\-_]+)[\\s\\r\\t\\n]*=[\\s\\r\\t\\n]*([\'"])((?:\\\\\\2|(?!\\2).)*)\\2',
        'ig'
      );
      const attributes = {};
      let match;
      while ((match = regex.exec(m[1]))) {
        attributes[match[1]] = match[3];
      }
      const newScript = document.createElement('script');
      Object.keys(attributes).forEach((x) => (newScript[x] = attributes[x]));
      try {
        newScript.textContent = this.processLiveCodeJavascript(m[2]);
        result.appendChild(newScript);
      } catch (err) {
        // If there's a syntax error in the script, catch it here
        this.pseudoConsole.error(err.message);
      }
    });

    try {
      this.outputStylesheets.forEach((x) => {
        const href = x.trim();
        if (href.length > 0) {
          htmlContent = `<link rel="stylesheet" href="${href}"></link>${htmlContent}`;
        }
      });
      const outputElement = shadowRoot.querySelector(
        'div.__code-playground-result > div.__code-playground-output'
      );
      if (outputElement) {
        if (htmlContent) outputElement.classList.add('visible');
        else outputElement.classList.remove('visible');
        outputElement.innerHTML = htmlContent;
      }
    } catch (e) {
      // If there's a syntax error in the markup, catch it here
      this.pseudoConsole.error(e.message);
    }

    // Add a new script tag
    const jsEditor = shadowRoot.querySelector(
      'textarea[data-language="javascript"] + .CodeMirror'
    );
    let jsContent = '';
    if (jsEditor) {
      jsContent = jsEditor['CodeMirror']?.getValue();
    } else {
      jsContent =
        shadowRoot.querySelector<HTMLTextAreaElement>(
          'textarea[data-language="javascript"]'
        )?.value ?? '';
    }

    // If there are any custom elements in the HTML wait for them to be
    // defined before executing the script which may refer to them
    for (const x of htmlContent.matchAll(
      /\<([a-zA-Z0-9]+\-[a-zA-Z0-9]*)[^\>]*\>/g
    )) {
      await customElements.whenDefined(x[1]);
    }

    const newScript = document.createElement('script');
    newScript.type = 'module';
    try {
      newScript.textContent = this.processLiveCodeJavascript(jsContent);
      // The script is executed when it is inserted in the DOM
      result.appendChild(newScript);
    } catch (err) {
      // If there's a syntax error in the script, catch it here
      this.pseudoConsole.error(err.message);
    }
    // Note: Error handling is now done within the scoped script execution
  }

  editorContentChanged(): void {
    if (this.resetting) return;

    this.edited = true;

    this.updateButtonBar();

    if (this.autorun !== 'never') {
      if (this.runTimer) clearTimeout(this.runTimer);
      if (this.autorun === 0) this.run();
      else this.runTimer = setTimeout(() => this.run(), this.autorun);
    }
  }

  reset(): void {
    this.resetting = true;
    if (this.runTimer) clearTimeout(this.runTimer);
    const slots = this.shadowRoot.querySelectorAll('.original-content slot');
    slots.forEach((slot: HTMLSlotElement) => {
      const text = slot
        .assignedNodes()
        .map((node: HTMLElement) => node.innerText)
        .join('');
      if (text) {
        const editor = this.shadowRoot.querySelector(
          `textarea[data-language="${slot.name}"] + .CodeMirror`
        );
        if (editor) {
          editor['CodeMirror']?.setValue(sanitizeInput(text));

          if (slot.name === 'javascript')
            mark(this.shadowRoot, 'javascript', this.markLine);
          else {
            mark(
              this.shadowRoot,
              slot.name,
              this.getAttribute(`mark-${slot.name}-line`)
            );
          }
        } else {
          const textarea = this.shadowRoot.querySelector<HTMLTextAreaElement>(
            `textarea[data-language="${slot.name}"]`
          );
          if (textarea) textarea.value = sanitizeInput(text);
        }
      }
    });
    this.updateButtonBar();
    this.run();
    this.edited = false;
    this.resetting = false;
    this.updateButtonBar();
  }

  get outputElement(): HTMLElement {
    return this.shadowRoot.querySelector('div.__code-playground-output');
  }

  get pseudoConsole(): Console & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    catch: (err: any) => void;
  } {
    const shadowRoot = this.shadowRoot;
    // root ?? (document.currentScript.getRootNode() as HTMLElement);
    let console = shadowRoot.querySelector<HTMLElement>(
      '.__code-playground-console'
    );
    if (!console) {
      const result = shadowRoot.querySelector('.__code-playground-result');
      if (!result) return { ...window.console, catch: () => {} };
      console = document.createElement('pre');
      console.classList.add('__code-playground-console');
      console.setAttribute('part', 'console');
      result.appendChild(console);
    }
    const that = this;
    const updateConsole = () => {
      console.innerHTML = this.consoleContent;
      if (this.consoleContent) {
        console.classList.add('visible');
        // Debug: force visibility
        console.style.display = 'block';
      } else {
        console.classList.remove('visible');
      }
      console.scrollTop = console.scrollHeight;
    };
    const appendConsole = (msg: string, cls?: string) => {
      console.classList.add('visible');
      echo(
        msg + '\n',
        (s) => {
          // Build the new line with proper styling
          const indent = '&nbsp;&nbsp;'.repeat(
            parseInt(console.dataset['group-level']) ?? 0
          );
          const newLine =
            indent + (cls ? `<span class="${cls}">${s}</span>` : s);

          // Append the new line to existing content
          that.consoleContent = (that.consoleContent || '') + newLine;
          console.innerHTML = that.consoleContent;
          console.scrollTop = console.scrollHeight;
        },
        () => updateConsole()
      );

      // msg += '\n';
      // this.consoleContent =
      //   (cls ? `<span class="${cls}">` : '') +
      //   lines.join('\n') +
      //   '&nbsp;&nbsp;'.repeat(parseInt(console.dataset['group-level']) ?? 0) +
      //   msg +
      //   (cls ? '</span>' : '');

      // updateConsole();
    };
    return {
      ...window.console,
      assert: (condition: boolean, ...args) => {
        if (!condition) {
          let msg = interpolate(args, { maxWidth: that.compactWidth });
          if (msg.length > 0) msg = ':\n   ' + msg;
          appendConsole('Assertion failed' + msg, 'error');
        }
      },
      // non-standard
      catch: (err) => {
        const m = err.stack.split('at ')[1].match(/:([0-9]+):([0-9]+)/) || [];
        appendConsole(
          (m[1] ? 'Line ' + parseInt(m[1]) + '\n   ' : '') + err.message,
          'error'
        );
      },
      clear: () => {
        this.consoleContent = '';
        updateConsole();
      },
      debug: (...args) =>
        appendConsole(interpolate(args, { maxWidth: that.compactWidth })),
      dir: (...args) =>
        appendConsole(interpolate(args, { maxWidth: that.compactWidth })),
      error: (...args) =>
        appendConsole(
          interpolate(args, { maxWidth: that.compactWidth }),
          'error'
        ),
      group: (...args) => {
        if (arguments.length > 0)
          appendConsole(
            interpolate(args, { maxWidth: that.compactWidth }),
            'group'
          );
        console.dataset['group-level'] = Number(
          (parseInt(console.dataset['group-level']) ?? 0) + 1
        ).toString();
      },
      groupCollapsed: (...args) => {
        if (arguments.length > 0)
          appendConsole(
            interpolate(args, { maxWidth: that.compactWidth }),
            'group'
          );
        console.dataset['group-level'] = Number(
          (parseInt(console.dataset['group-level']) ?? 0) + 1
        ).toString();
      },
      groupEnd: () => {
        console.dataset['group-level'] = Number(
          (parseInt(console.dataset['group-level']) ?? 0) - 1
        ).toString();
      },
      info: (...args) =>
        appendConsole(
          interpolate(args, { maxWidth: that.compactWidth }),
          'info'
        ),
      log: (...args) => {
        const msg = interpolate(args, { maxWidth: that.compactWidth });
        appendConsole(msg, 'log');
      },
      warn: (...args) =>
        appendConsole(
          interpolate(args, { maxWidth: that.compactWidth }),
          'warning'
        ),
      time: (label) => {
        this.timers[label] = Date.now();
      },
      timeEnd: (label, ...args) => {
        if (!this.timers[label])
          return appendConsole(
            interpolate(args, { maxWidth: that.compactWidth }),
            'log'
          );
        const time = Date.now() - this.timers[label];
        if (time > 1000) {
          // Display two digits after the decimal point
          return appendConsole(
            `${interpolate(args, {
              maxWidth: that.compactWidth,
            })}\n${label}: ${Number(time / 1000).toFixed(2)}s`,
            'log'
          );
        }
        return appendConsole(
          `${interpolate(args, {
            maxWidth: that.compactWidth,
          })}\n${label}: ${time}ms`,
          'log'
        );
      },
    };
  }

  /**
   * Process a script fragment to be able to run inside the playground
   * - replace querySelector/querySelectoAll calls
   * - replace `console.*` calls
   * - extract imports
   * - wrap in a try/catch block
   */
  processLiveCodeJavascript(script: string): string {
    if (!script) return '';
    const jsID = randomJavaScriptId();

    // Replace document.querySelector.* et al with section.querySelector.*
    script = script.replace(
      /([^a-zA-Z0-9_-]?)document(\s*\.\s*querySelector\s*\()/g,
      '$1output' + jsID + '$2'
    );
    script = script.replace(
      /([^a-zA-Z0-9_-]?)document(\s*\.\s*querySelectorAll\s*\))/g,
      '$1output' + jsID + '$2'
    );

    script = script.replace(
      /([^a-zA-Z0-9_-]?)document(\s*\.\s*)getElementById\s*\(/g,
      '$1output' + jsID + '$2' + "querySelector('#'+"
    );

    // Replace console.* with pseudoConsole.*
    // script = script.replace(
    //   /([^a-zA-Z0-9_-])?console(\s*\.\s*)/g,
    //   '$1console' + jsID + '$2'
    // );

    // Extract import (can't be inside a try...catch block)
    const imports = [];
    script = script.replace(
      /([^a-zA-Z0-9_-]?import.*)('.*'|".*");/g,
      (match, p1, p2) => {
        imports.push([match, p1, p2.slice(1, p2.length - 1)]);
        return `/* ${p1}${p2} */`;
      }
    );

    // Important: keep the ${script} on a separate line. The content could
    // be "// a comment" which would result in the script failing to parse
    //
    // Note: the function is marked `async` so that await can be used in its body

    const pseudoConsole = this.pseudoConsole;
    const outputElement = this.outputElement;

    // Store references globally so the script can access them
    window[`pseudoConsole${jsID}`] = pseudoConsole;
    window[`outputElement${jsID}`] = outputElement;

    // Create error catching wrapper function for this playground
    (window as any)[`errorCatcher${jsID}`] = function (fn) {
      return function (...args) {
        try {
          return fn.apply(this, args);
        } catch (error) {
          pseudoConsole.error('Uncaught Error: ' + (error.message || error));
          // Don't re-throw - we've handled it in the pseudo-console
          return undefined;
        }
      };
    };

    return (
      imports
        .map((x) => {
          if (this.moduleMap[x[2]]) return `${x[1]} "${this.moduleMap[x[2]]}";`;
          return x[0];
        })
        .join('') +
      `
(function() {
  const originalConsole = window.console;
  const pseudoConsole = window.pseudoConsole${jsID};
  const output${jsID} = window.outputElement${jsID};
  
  // Override console methods directly
  const console = {
    ...originalConsole,
    log: (...args) => pseudoConsole.log(...args),
    warn: (...args) => pseudoConsole.warn(...args),
    error: (...args) => pseudoConsole.error(...args),
    info: (...args) => pseudoConsole.info(...args),
    debug: (...args) => pseudoConsole.debug(...args),
    dir: (...args) => pseudoConsole.dir(...args),
    clear: () => pseudoConsole.clear(),
    time: (label) => pseudoConsole.time(label),
    timeEnd: (label) => pseudoConsole.timeEnd(label),
    group: (...args) => pseudoConsole.group(...args),
    groupEnd: () => pseudoConsole.groupEnd(),
    assert: (condition, ...args) => pseudoConsole.assert(condition, ...args)
  };

  // Create wrapped versions of async functions that catch errors
  const errorCatcher = window.errorCatcher${jsID};
  const originalSetTimeout = window.setTimeout;
  const originalSetInterval = window.setInterval;
  
  // Override setTimeout and setInterval to wrap callbacks
  window.setTimeout = function(callback, delay, ...args) {
    if (typeof callback === 'function') 
      callback = errorCatcher(callback);
    return originalSetTimeout.call(this, callback, delay, ...args);
  };
  
  window.setInterval = function(callback, delay, ...args) {
    if (typeof callback === 'function') 
      callback = errorCatcher(callback);
    return originalSetInterval.call(this, callback, delay, ...args);
  };
  
  try {
${script}
  } catch(scriptError) {
    console.error(scriptError.message || scriptError);
  }
  
  // Restore original functions and clean up
  originalSetTimeout(() => {
    window.setTimeout = originalSetTimeout;
    window.setInterval = originalSetInterval;
    delete window.pseudoConsole${jsID};
    delete window.outputElement${jsID};
    delete window.errorCatcher${jsID};
  }, 1000);
})();`
    );
  }

  //
  // Property/attributes
  //

  // 'showLineNumbers' is true if line numbers should be displayed
  get showLineNumbers(): boolean {
    return (
      this.hasAttribute('show-line-numbers') ||
      this.hasAttribute('showLineNumbers')
    );
  }

  set showLineNumbers(val: boolean) {
    this.removeAttribute('showLineNumbers');
    if (val) this.setAttribute('show-line-numbers', '');
    else this.removeAttribute('show-line-numbers');
  }

  get markLine(): string {
    return (
      this.getAttribute('mark-line') ||
      this.getAttribute('markLine') ||
      this.getAttribute('mark-javascript-line') ||
      this.getAttribute('markJavaScriptLine')
    );
  }

  set markLine(val: string) {
    this.removeAttribute('markLine');
    this.setAttribute('mark-line', val);
  }
}

function randomId() {
  return (
    'i' +
    (Date.now().toString(36).slice(-2) +
      Math.floor(Math.random() * 0x186a0).toString(36))
  );
}

function randomJavaScriptId() {
  return (
    Date.now().toString(26).slice(-2) +
    Math.floor(Math.random() * 0x186a0).toString(26)
  );
}

const INDENT = '  ';

/**
 * Convert a basic type or an object into a HTML string
 */
function asString(
  depth: number,
  value: unknown,
  options: {
    quote?: string;
    ancestors?: Record<string, any>[];
    maxCompactWidth?: number;
  } = {}
): { text: string; charCount: number; itemCount: number; lineCount: number } {
  options.quote ??= '"';
  options.ancestors ??= [];
  options.maxCompactWidth ??= 80; // Configurable threshold, default 80 chars

  //
  // BOOLEAN
  //
  if (typeof value === 'boolean') {
    return {
      text: `<span class="boolean">${escapeHTML(String(value))}</span>`,
      charCount: String(value).length,
      itemCount: 1,
      lineCount: 1,
    };
  }

  //
  // NUMBER
  //
  if (typeof value === 'number') {
    return {
      text: `<span class="number">${escapeHTML(String(value))}</span>`,
      charCount: String(value).length,
      itemCount: 1,
      lineCount: 1,
    };
  }
  //
  // STRING
  //
  if (typeof value === 'string') {
    if (options.quote.length === 0) {
      return {
        text: escapeHTML(value),
        charCount: String(value).length,
        itemCount: 1,
        lineCount: value.split(/\r\n|\r|\n/).length,
      };
    }
    return {
      text: `<span class="string">${escapeHTML(
        options.quote + value + options.quote
      )}</span>`,
      charCount: value.length + options.quote.length * 2,
      itemCount: 1,
      lineCount: value.split(/\r\n|\r|\n/).length,
    };
  }

  //
  // FUNCTION
  //
  if (typeof value === 'function') {
    let functionValue = '';
    if ('toString' in value) functionValue = escapeHTML(value.toString());
    else functionValue = escapeHTML(String(value));

    return {
      text: `<span class="function">ƒ  ${functionValue}</span>`,
      charCount: functionValue.length + 3, // 3 for the "ƒ "
      itemCount: 1,
      lineCount: functionValue.split(/\r\n|\r|\n/).length,
    };
  }

  //
  // NULL/UNDEFINED
  //
  if (value === null || value === undefined) {
    return {
      text: `<span class="null">${escapeHTML(String(value))}</span>`,
      charCount: String(value).length,
      itemCount: 1,
      lineCount: 1,
    };
  }

  // Avoid infinite recursions (e.g. `window.window`)
  if (depth > 20) {
    return {
      text: '<span class="sep">(...)</span>',
      charCount: 5,
      itemCount: 1,
      lineCount: 1,
    };
  }

  //
  // ARRAY
  //
  if (Array.isArray(value)) {
    if (options.ancestors.includes(value))
      return {
        text: '<span class="sep">[...]</span>',
        charCount: 5,
        itemCount: 1,
        lineCount: 1,
      };

    const result = [];
    // To account for sparse array, we can't use map() (it skips over empty slots)
    for (let i = 0; i < value.length; i++) {
      if (Object.keys(value).includes(Number(i).toString())) {
        result.push(
          asString(depth + 1, value[i], {
            ancestors: [...options.ancestors, value],
            maxCompactWidth: options.maxCompactWidth,
          })
        );
      } else {
        result.push({
          text: '<span class="empty">empty</span>',
          charCount: 5,
          itemCount: 1,
          lineCount: 1,
        });
      }
    }
    const itemCount = result.reduce((acc, val) => acc + val.itemCount, 0);
    const lineCount = result.reduce(
      (acc, val) => Math.max(acc, val.lineCount),
      0
    );
    const charCount = result.reduce((acc, val) => acc + val.charCount + 2, 0);
    if (charCount > options.maxCompactWidth || lineCount > 1) {
      return {
        text:
          "<span class='sep'>[</span>\n" +
          INDENT.repeat(depth + 1) +
          result
            .map((x, i) => '<span class="index">' + i + '</span>' + x.text)
            .join("<span class='sep'>, </span>\n" + INDENT.repeat(depth + 1)) +
          '\n' +
          INDENT.repeat(depth) +
          "<span class='sep'>]</span>",

        charCount:
          result.reduce((acc, val) => acc + val.charCount, 0) +
          2 * (itemCount - 1),
        itemCount,
        lineCount: 2 + result.reduce((acc, val) => acc + val.lineCount, 0),
      };
    }
    // Compact serialization on one line
    return {
      text:
        "<span class='sep'>[</span>" +
        result.map((x) => x.text).join("<span class='sep'>, </span>") +
        "<span class='sep'>]</span>",
      charCount,
      itemCount: Math.max(1, itemCount),
      lineCount: 1,
    };
  }

  //
  // HTMLElement
  //
  if (value instanceof Element) {
    if (options.ancestors.includes(value))
      return {
        text: '<span class="object">Element...</span>',
        charCount: 10,
        itemCount: 1,
        lineCount: 1,
      };

    let result = `<${value.localName}`;
    let lineCount = 1;
    Array.from(value.attributes).forEach((x) => {
      result += ' ' + x.localName;
      const val = value.getAttribute(x.localName);
      if (val.length > 0) result += '="' + val + '"';
    });
    result += '>';

    if (value.innerHTML) {
      let content = value.innerHTML.split('\n');
      if (content.length > 4) {
        content = [...content.slice(0, 5), '(...)\n'];
      }
      result += content.join('\n');
      lineCount += content.length;
    }

    result += `</${value.localName}>`;
    return {
      text: `<span class="object">${escapeHTML(result)}</span>`,
      charCount: result.length,
      itemCount: 1,
      lineCount: lineCount,
    };
  }

  //
  // OBJECT
  //
  if (typeof value === 'object') {
    if (options.ancestors.includes(value))
      return {
        text: '<span class="sep">{...}</span>',
        charCount: 5,
        itemCount: 1,
        lineCount: 1,
      };

    if (value instanceof Map) {
      const kv = Object.fromEntries(value);
      const result = asString(depth, kv, {
        ancestors: [...options.ancestors, value],
        maxCompactWidth: options.maxCompactWidth,
      });
      return { ...result, text: '<span class=object>Map</span>' + result.text };
    }
    if (value instanceof Set) {
      const elts = Array.from(value);
      const result = asString(depth, elts, {
        ancestors: [...options.ancestors, value],
        maxCompactWidth: options.maxCompactWidth,
      });
      return { ...result, text: '<span class=object>Set</span>' + result.text };
    }

    if ('toString' in value) {
      const s = value.toString();
      if (s !== '[object Object]')
        return {
          text: escapeHTML(s),
          charCount: s.length,
          itemCount: 1,
          lineCount: 1,
        };
    }
    let props = Object.keys(value);

    Object.getOwnPropertyNames(value).forEach((prop) => {
      if (!props.includes(prop)) {
        props.push(prop);
      }
    });

    // If this is not a plain literal object, filter out properties that
    // start with an underscore
    if (Object.getPrototypeOf(value) !== Object.prototype)
      props = props.filter((x) => !x.startsWith('_'));
    if (props.length === 0 && typeof props.toString === 'function') {
      const result = value.toString();
      if (result === '[object Object]')
        return {
          text: '<span class="sep">{}</span>',
          charCount: 2,
          itemCount: 1,
          lineCount: 1,
        };
      return {
        text: result,
        charCount: result.length,
        itemCount: 1,
        lineCount: result.split(/\r\n|\r|\n/).length,
      };
    }

    const propStrings = props.sort().map((key) => {
      if (typeof value[key] === 'object' && value[key] !== null) {
        let result = asString(depth + 1, value[key], {
          ancestors: [...options.ancestors, value],
          maxCompactWidth: options.maxCompactWidth,
        });
        if (result.itemCount > 500) {
          result = {
            text: "<span class='sep'>(...)</span>",
            charCount: 5,
            itemCount: 1,
            lineCount: 1,
          };
        }
        return {
          text: `<span class="property">${key}</span><span class='sep'>: </span>${result.text}`,
          charCount: result.charCount + key.length + 2, // 2 for the ": "
          itemCount: result.itemCount,
          lineCount: result.lineCount,
        };
      }
      if (typeof value[key] === 'function') {
        return {
          text: `<span class="property">${key}</span></span><span class='sep'>: </span><span class='function'>ƒ (...)</span>`,
          charCount: key.length + 2 + 3, // 2 for the ": ", 3 for "ƒ (...)"
          itemCount: 1,
          lineCount: 1,
        };
      }
      const result = asString(depth + 1, value[key], {
        ancestors: [...options.ancestors, value],
        maxCompactWidth: options.maxCompactWidth,
      });
      return {
        text: `<span class="property">${key}</span><span class='sep'>: </span>${result.text}`,
        charCount: result.charCount + key.length + 2, // 2 for the ": "
        itemCount: result.itemCount,
        lineCount: result.lineCount,
      };
    });
    const itemCount = propStrings.reduce((acc, val) => acc + val.itemCount, 0);
    const lineCount = propStrings.reduce((acc, val) => acc + val.lineCount, 0);
    const charCount =
      propStrings.reduce((acc, val) => acc + val.charCount, 0) +
      2 * (itemCount - 1); // 2 for the ", "

    if (lineCount === 1 && charCount <= options.maxCompactWidth) {
      return {
        text:
          "<span class='sep'>{</span>" +
          propStrings
            .map((x) => x.text)
            .join("</span><span class='sep'>, </span>") +
          "<span class='sep'>}</span>",
        charCount,
        itemCount,
        lineCount,
      };
    }
    return {
      text:
        "<span class='sep'>{</span>\n" +
        INDENT.repeat(depth + 1) +
        propStrings
          .map((x) => x.text)
          .join(
            "</span><span class='sep'>,</span>\n" + INDENT.repeat(depth + 1)
          ) +
        '\n' +
        INDENT.repeat(depth) +
        "<span class='sep'>}</span>",
      charCount:
        propStrings.reduce((acc, val) => acc + val.charCount + 2, 0) +
        2 * (itemCount - 1), // 2 for the ", "
      // 2 for the "{ }"
      itemCount: itemCount,
      lineCount: lineCount + 2,
    };
  }
  return {
    text: String(value),
    charCount: String(value).length,
    itemCount: 1,
    lineCount: 1,
  };
}

function interpolate(
  args: unknown[],
  options: { maxWidth: number } = { maxWidth: 80 }
): string {
  const format = args[0];
  const rest = args.slice(1);

  if (typeof format === 'string' && format.includes('%') && rest.length) {
    const string = format.replace(
      /(%[oscdif]|%(\d*)\.(\d*)[dif])/g,
      (all, key, width = '', dp): string => {
        if (key === '%o') {
          // object
          return asString(0, rest.shift(), {
            maxCompactWidth: options.maxWidth,
          }).text;
        }

        if (key === '%s') {
          // string
          return rest.shift() as string;
        }

        if (key === '%c') {
          return `</span><span style="${rest.shift()}">`;
        }

        const value = rest.shift();
        let res = null;

        if (key.substr(-1) === 'f' && typeof value === 'number') {
          if (isNaN(parseInt(dp, 10))) {
            res = value;
          } else {
            res = value.toFixed(dp);
          }
        } else if (typeof value === 'string') {
          res = parseInt(value, 10);
        }

        if (width === '') {
          return res;
        }

        return asString(0, res, {
          maxCompactWidth: options.maxWidth,
        }).text.padStart(width, ' ');
      }
    );

    return string;
  }

  return args
    .map(
      (x) =>
        asString(0, x, { quote: '', maxCompactWidth: options.maxWidth }).text
    )
    .join(' ');
}

function escapeHTML(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function sanitizeInput(s: string): string {
  s = s.trim();

  // Remove XML comments, including the <!-- htmlmin:ignore --> used to
  // indicate to terser to skip sections, so as to preserve the formatting.
  s = s.replace(/<!--.*-->\n?/g, '');

  // Remove lines with only a `//`
  s = s
    .split('\n')
    .map((x) => (x.trim() === '//' ? '' : x))
    .join('\n');
  return s;
}

function mark(root: ShadowRoot, language: string, arg: string | undefined) {
  if (arg === undefined) return;
  const editor = root.querySelector(
    `textarea[data-language="${language}"] + .CodeMirror`
  )?.['CodeMirror'];

  if (!editor) return;

  // Remove any marked lines
  for (let i = editor.doc.firstLine(); i <= editor.doc.lastLine(); i++)
    editor.doc.removeLineClass(i, 'wrap', 'marked');

  // Mark the lines
  // Either "5", or "5-6", or "5, 7, 9", or "5-7, 9"
  if (typeof arg === 'string') {
    for (let item of arg.split(',')) {
      item = item.trim();
      if (item === '' || item === 'none') continue;
      if (/\d+-\d+/.test(item)) {
        let [, from, to] = arg.match(/(\d+)-(\d+)/);
        for (
          let i = parseInt(from);
          i <= Math.max(parseInt(from), parseInt(to));
          i++
        )
          editor.doc.addLineClass(i - 1, 'wrap', 'marked');
        return;
      } else {
        editor.doc.addLineClass(parseInt(arg) - 1, 'wrap', 'marked');
      }
    }
  }
}

// Register the tag for the element, only if it isn't already registered
customElements.get('code-playground') ??
  customElements.define('code-playground', CodePlaygroundElement);

function echo(
  rest: string,
  tty: (s: string) => void,
  finalize: () => void,
  output?: string
) {
  tty(output ?? '' + rest);
  finalize();

  // if (!rest) {
  //   finalize();
  //   return;
  // }

  // let delay = 4;
  // setTimeout(
  //   () =>
  //     requestAnimationFrame(() => {
  //       tty((output ?? '') + rest[0]);
  //       echo(rest.substring(1), tty, finalize, (output ?? '') + rest[0]);
  //     }),
  //   delay
  // );
}

function toTitleCase(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
